import { v4 as uuid } from 'uuid';
import { SegmentType } from '../../../shared/types';

export const getModifiedSegmentData = (data: SegmentType): SegmentType => ({
  ...(data || {}),
  rule: {
    ...(data?.rule || { match_type: 'ANY' }),
    condition_sets: [...(data.rule?.condition_sets || [])].map(
      (condition_set) => ({
        ...(condition_set || {}),
        conditions: [...(condition_set.conditions || [])].map((condition) => ({
          ...condition,
          id: uuid(),
        })),
        id: uuid(),
      }),
    ),
  },
});
